import { getBaseValueForEffectivePurchase } from "../../../../utils/utils";

/**
 * Predicado base de elegibilidade para ordem de compra.
 * Considera apenas os valores originais, sem inputs do usuário.
 * Essa estratégia filtra os produtos que na UI aparecem com compra final 0.
 * Exportado para reuso em outras strategies do mesmo módulo.
 */
export const isEligibleForPurchase = (item) => {
  const data = { item, conditionValue: true };
  const baseValue = getBaseValueForEffectivePurchase({ data });

  if (baseValue > 0) {
    return true;
  }

  return false;
};

/**
 * Estratégia: verifica se há itens elegíveis para ordem de compra
 * considerando apenas os valores originais, sem inputs do usuário.
 * Utilizada em contextos onde edição de quantidades não está disponível,
 * como no PurchaseFlow.
 */
export const withOriginalValues = ({ filteredData }) => {
  if (!filteredData?.length) return false;
  return filteredData.some(item => isEligibleForPurchase(item));
};